import {Typography, TypographyProps} from '@material-ui/core'

type Props = TypographyProps & {
  children: React.ReactNode
  style?: any
}
const Body1: React.FC<Props> = (props: Props) => {
  let color = props.color
  if (!color) {
    color = 'textPrimary'
  }
  return (
    <Typography variant="body1" {...props} color={color} style={{...props.style}}>
      {props.children}
    </Typography>
  )
}

export default Body1
